import { useMemo, useState } from 'react';
import { PopupCard } from './popup-card';
import { popupListData } from './data';
import { getCurrentCardIndex, shouldPopupCard } from './utils';

export function NewControllerPromoBanner() {
  const [show, setShow] = useState(shouldPopupCard());
  const data = useMemo(() => {
    const proposedIndex = getCurrentCardIndex() + 1;
    const nextBannerIndex = proposedIndex >= popupListData.length ? 0 : proposedIndex;
    return { ...popupListData[nextBannerIndex], index: nextBannerIndex };
  }, []);
  return show ? <PopupCard {...data} setShow={setShow} /> : null;
}
